$(function () {
  // handle checkbox group validity, if checkbox field required
  var watchRequiredCheckboxes = function (collection) {
    collection.on('change', function (e) {
      // find siblings per field name
      var checkboxGroup = collection.filter(
        '[name="' + $(this).attr('name') + '"]'
      );
      var isChecked = checkboxGroup.is(':checked');
      // add or remove the 'required' prop depending on if
      // an option within the group is checked
      checkboxGroup.prop('required', !isChecked);
    });
  };
  // watch form's regular required checkboxes
  var requiredCheckboxes = $(':checkbox[aria-required="true"]');
  watchRequiredCheckboxes(requiredCheckboxes);

  // watch required checkboxes revealed by conditional fieldsets
  $('.toggle-box,.radio-toggle').on('change', function (e) {
    var divID = $(this).attr('value');
    var requiredConditionals = $(`#${divID}`).find(
      ':checkbox[aria-required="true"]'
    );
    watchRequiredCheckboxes(requiredConditionals);
  });

  // Run a custom function when the form is submitted
  $('#new_submission').on('submit', function () {
    // Check validity using the built-in function
    if ($('#new_submission')[0].checkValidity()) {
      // Then check validity of all files in file fields
      $('input[type="file"]').each(function (a) {
        if (a != undefined && a.accept != undefined) {
          if (!new RegExp(a.accept.replace('*', '.*')).test(a.files[0].type))
            return false;
        }
      });

      // If errors present, prevent form submission
      // Else show the spinner while the submission processes
      if ($('ul.errors').length > 0) {
        console.log('validation errors present');
        return false;
      } else {
        $('.opaque-spinner-bg').css('display', 'flex');
        return true;
      }
    } else {
      // trigger the flash message
      $('.file-warning').css('display', 'block');
      return false;
    }
  });
});
